import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const uploadCloudVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type UploadCloudProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof uploadCloudVariants> &
  IconProps;

export const UploadCloud = React.forwardRef<SVGSVGElement, UploadCloudProps>(
  (
    {
      className,
      variant,
      viewBox = '0 0 40 40',
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill={fill}
        className={cn(
          uploadCloudVariants({
            variant,
            className,
          }),
        )}
        ref={ref}
        {...props}
      >
        <path d="M7.13329 8.36782C7.52115 6.03111 8.72576 3.90789 10.5326 2.37624C12.3395 0.84458 14.6313 0.00390625 17 0.00390625C19.3686 0.00390625 21.6604 0.84458 23.4673 2.37624C25.2741 3.90789 26.4788 6.03111 26.8666 8.36782C27.8574 8.46069 28.8199 8.74982 29.6978 9.21836C30.5758 9.6869 31.3517 10.3255 31.9804 11.0969C32.6091 11.8683 33.078 12.7571 33.3598 13.7116C33.6416 14.666 33.7306 15.667 33.6216 16.6562C32.3201 14.6229 30.3768 13.0827 28.1 12.2799C25.8233 11.4771 23.3437 11.4578 21.0547 12.225C18.7657 12.9922 16.7986 14.5019 15.4656 16.5146C14.1325 18.5273 13.5099 20.9276 13.6966 23.3345H7.83329C5.89955 23.3424 4.03749 22.603 2.63584 21.2708C1.23418 19.9386 0.401252 18.1165 0.310928 16.1849C0.220604 14.2532 0.879865 12.3613 2.15109 10.9042C3.42231 9.44696 5.20725 8.53709 7.13329 8.36449V8.36782ZM33.6666 22.5011C33.6666 24.9323 32.7009 27.2639 30.9818 28.983C29.2627 30.702 26.9311 31.6678 24.5 31.6678C22.0688 31.6678 19.7372 30.702 18.0181 28.983C16.2991 27.2639 15.3333 24.9323 15.3333 22.5011C15.3333 20.07 16.2991 17.7384 18.0181 16.0193C19.7372 14.3003 22.0688 13.3345 24.5 13.3345C26.9311 13.3345 29.2627 14.3003 30.9818 16.0193C32.7009 17.7384 33.6666 20.07 33.6666 22.5011ZM23.6666 27.5011C23.6666 27.7222 23.7544 27.9341 23.9107 28.0904C24.067 28.2467 24.2789 28.3345 24.5 28.3345C24.721 28.3345 24.9329 28.2467 25.0892 28.0904C25.2455 27.9341 25.3333 27.7222 25.3333 27.5011V19.5128L28.0766 22.2578C28.2331 22.4143 28.4453 22.5022 28.6666 22.5022C28.8879 22.5022 29.1001 22.4143 29.2566 22.2578C29.4131 22.1013 29.501 21.8891 29.501 21.6678C29.501 21.4465 29.4131 21.2343 29.2566 21.0778L25.09 16.9111C25.0125 16.8335 24.9206 16.772 24.8193 16.73C24.7181 16.688 24.6096 16.6663 24.5 16.6663C24.3903 16.6663 24.2818 16.688 24.1806 16.73C24.0793 16.772 23.9874 16.8335 23.91 16.9111L19.7433 21.0778C19.5868 21.2343 19.4989 21.4465 19.4989 21.6678C19.4989 21.8891 19.5868 22.1013 19.7433 22.2578C19.8998 22.4143 20.112 22.5022 20.3333 22.5022C20.5546 22.5022 20.7668 22.4143 20.9233 22.2578L23.6666 19.5128V27.5011Z" />
      </svg>
    );
  },
);

UploadCloud.displayName = 'UploadCloud';
